'use strict';

frontendApp.directive('iioPopoverPopup', [function () {
    return {
        restrict: 'EA',
        scope: { icon: '@', title: '@', content: '@', placement: '@', animation: '&', isOpen: '&' },
        templateUrl: 'partials/popover.html'
    };
}]);
